const observer = new IntersectionObserver(
    entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                entry.target.play();
                observer.unobserve(entry.target);
                if(!entry.target.paused) {
                    $(entry.target).siblings('.play-reset-contain').find('.playVideo').addClass('hideIcon');
                    $(entry.target).siblings('.play-reset-contain').find('.pauseVideo').removeClass('hideIcon');
                }
            }
        });
    },
    {
        root: null, 
        rootMargin: '0px',
        threshold: 0.2  
    }
);

const targets = document.querySelectorAll('.autoplayinview video');
for (const target of targets) {
    observer.observe(target);
}


$('.playVideo').click(function() {
    let video = $(this).parent().siblings('video').get(0);
    video.play();
    if(!video.paused) {
        $(this).addClass('hideIcon');
        $(this).parent().find('.pauseVideo').removeClass('hideIcon');
    }
});

$('.pauseVideo').click(function() {
    let video = $(this).parent().siblings('video').get(0);
    video.pause();
    if(video.paused) {
        $(this).addClass('hideIcon');
        $(this).parent().find('.playVideo').removeClass('hideIcon');
    }
});

$('.resetVideo').click(function() {
    let video = $(this).parent().siblings('video').get(0);
    video.currentTime = 0;
});